import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../auth";
import { ROUTES } from "../../routes";

const PrivateRoute = () => {
  const { isAuthenticated, isLoading: isLoadingAuth } = useAuth();

  if (isLoadingAuth) {
    return <></>;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.SIGN_IN} />;
  }

  return <Outlet />;
};

export { PrivateRoute };
